export enum CloudDeliveryPromiseType {
    AvailableForHomeDelivery = "AVAILABLE_FOR_HOME_DELIVERY",
    AvailableForS2S = "AVAILABLE_FOR_S2S",
    AvailableForPickUpInStore = "AVAILABLE_FOR_CLICK_AND_COLLECT",
    OnlyAvailableOffline = "ONLY_AVAILABLE_OFFLINE",
    NoStock = "UNAVAILABLE"
}
